import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { throwError } from 'rxjs';

import { environment } from '../../../environments/environment';

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  protected http = inject(HttpClient);

  protected getApiUrl(action: string): string {
    return API_URL + action;
  }

  protected handleError(error: Response | any) {
    console.error('ApiService::handleError', error);
    return throwError(error);
  }
}
